import { TextField, Typography, Grid, InputAdornment, IconButton, Button, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SearchInput = ({ searchValue, setSearchValue, setCurriculumId, setData, searchUser, isForeigner }) => (
  <>
    <Grid
      item
      xs={12}
    >
      <Typography
        sx={{ textAlign: "center", padding: "4rem 1rem 1rem 1rem" }}
        color={"darkRed"}
        fontSize={24}
        paddingY={2}
        fontWeight={"bold"}
      >
        {isForeigner ? "Въведете Имейл" : "Въведете ЕГН"}
      </Typography>
    </Grid>
    <Box
      sx={{
        display: "flex",
        flexWrap: {
          xs: "wrap",
          lg: "nowrap",
        },
        gap: 2,
        justifyContent: "center",
        width: "fit-content",
        marginX: "auto",
        marginY: "2rem",
        padding: "1rem 1rem 4rem 1rem",
      }}
    >
      <TextField
        variant="outlined"
        sx={{ margin: "auto", width: "280px" }}
        label={isForeigner ? "Имейл" : "ЕГН"}
        name={isForeigner ? "email" : "personId"}
        fullWidth
        value={searchValue}
        onChange={e => {
          const value = e.target.value;

          setCurriculumId(null);
          setSearchValue(value || null);
        }}
        InputProps={{
          endAdornment: searchValue && (
            <InputAdornment position="end">
              <IconButton
                onClick={() => {
                  setSearchValue("");
                  setCurriculumId(null);
                  setData(null);
                }}
                edge="end"
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Button
        sx={{ margin: "auto", width: "130px" }}
        onClick={searchUser}
        size="large"
        variant="contained"
      >
        Провери
      </Button>
    </Box>
  </>
);
export default SearchInput;
